import { css } from "@emotion/react";
import backgroundBody from "../../../assets/images/background-body.jpg";
import playerBackgroundImg from "../../../assets/images/img-player-container.png";
import backgroundPlayersImg from "../../../assets/images/background-body.jpg";
import playerBackground from "../../../assets/images/img-player-container.png";
import coachNameBackground from "../../../assets/images/img-home_coaches-container_name.png";

export const headerStyle = (theme) => `css
    width: 100%;
    height: 100%;
    position: relative;
    top: 0.4rem;
    
  
    .playersHeaderImage {    
      margin-top: 3rem;
      background: rgb(121,201,66);
      background: linear-gradient(189deg, rgba(121,201,66,0.768411759234944) 60%, rgba(5,116,187,1) 100%);
     
     .playerHeaderTitle {
      margin: auto;
      display: flex;
      flex-direction: column; 
      max-width: ${theme.contentMaxWidth};

      span {
        margin-top: 20px;
        margin-bottom: 20px;
        display: flex;
        justify-content: center;
        opacity: 0.8;
        font-size: 50px;
        text-transform: uppercase;  
        color: #fff;
     
      }
      // .span{

      //   @media( max-width: 900px){
      //     margin-top:10px;
      //     font-size:40px;
      //     width:90%;
      //     margin-left:20px;
      //   }
      // }

      
      @media (max-width: 1020px) {
        span {
          display: none;       
        }
      }
     
     }         
    
    }

    .spinner{
      position: relative;
    }
    .spinner-container {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .playersBackgroundImg {
      border: solid 0.2px ${theme.dark ? "#303841" : "#fff"};
      background-image: url(${theme.dark ? null : backgroundBody});
      background-size: cover;
     
    } 
    .playersTitle{
      margin-top:10px;
      font-size:40px;
      margin-bottom:30px;
     width:90%;
     margin-left:20px;
    }
    @media(min-width: 1024px) {
      .playersTitle{
        display: none;
     
      }
    }
    
  `;
export const style = (theme) => css`
  margin: 4rem auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;

  // max-width: ${theme.contentMaxWidth};
  // padding: ${theme.padding};

  .players-at-home {
    margin: 0 auto;
    .image-players {
    }
  }

  @media (max-width: 700px) {
    padding: ${theme.paddingM};
  }
  .tab-menu {
    width: 65%;
    @media (max-width: 900px) {
      width: 90%;
    }
  }
  .go-back-btn {
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 65%;

    @media (max-width: 900px) {
      width: 90%;
      margin-left: 20px;
    }
  }
  .less-width {
    @media (min-width: 900px) {
      width: 65% !important;
    }
    @media (max-width: 1650px) {
      h3 {
        font-size: 1.3rem !important;
      }
    }
    @media (max-width: 650px) {
      h3 {
        font-size: 1rem !important;
      }
    }
  }
  .players-container {
    .title-group {
      font-size: 36px;
      margin-top: 20px;
      margin-bottom: 40px;
      @media (min-width: 900px) {
        font-size: 50px;
      }
    }
    // margin-left: 0.5rem;
    margin-top: 2rem;
    width: 100%;
    height: 100%;
    // max-width: ${theme.contentMaxWidth};
    overflow: hidden;
    @media (min-width: 900px) {
      width: 65%;
    }
    @media (max-width: 700px) {
      padding: 0 0.25rem;

      .title-group {
        font-size: 28px;
        margin-top: 10px;
        margin-bottom: 18px;
        line-height: 1.05;
      }
    }

    @media (max-width: 700px) {
      height: auto !important;
      overflow: visible !important;
      margin-top: 1rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 1rem;

      .players {
        display: flex !important;
        flex-direction: column;
        align-items: center;
        gap: 0.9rem;
      }
    }

    // .tab-menu {
    //   @media (max-width: 900px) {
    //   }
    // }
  }

  .back-button {
    display: flex;
    align-items: center;
    margin-bottom: 2rem;

    /* margin-left: 0.5rem; */
    cursor: pointer;
    width: fit-content;
    color: ${theme.accentColor2};
    text-decoration: none;
    .icon-container {
      svg {
        margin-top: -1rem;
        display: block;
      }
    }
    p {
      //margin: 0.4rem 0.5rem;
      //margin-bottom: 4rem;
    }
  }

  .player-card {
    position: absolute;
    cursor: pointer;
    display: block;
    width: clamp(260px, 18vw, 360px);
    aspect-ratio: 3 / 4; /* or tweak to taste */
    border-radius: 24px;
    overflow: hidden;
    background: ${theme.dark
      ? "rgba(8, 16, 28, 0.9)"
      : "rgba(255, 255, 255, 0.88)"};
    box-shadow: 0 18px 40px rgba(8, 16, 28, 0.14);
    transform-origin: center;
    transition:
      transform 220ms ease,
      box-shadow 220ms ease;
    z-index: 0;

    &:hover {
      z-index: 20;
      box-shadow: 0 24px 48px rgba(8, 16, 28, 0.22);
      transform: translateY(-8px);
    }

    .text-container {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 3;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-end;
      gap: 0.1rem;
      padding: 1rem 1rem 1.05rem;
      text-align: center;
      color: #fff;
      background: linear-gradient(
        180deg,
        rgba(8, 16, 28, 0) 0%,
        rgba(8, 16, 28, 0.55) 28%,
        rgba(8, 16, 28, 0.92) 100%
      );
      text-shadow: 0 2px 10px rgba(0, 0, 0, 0.35);
    }

    .player-name {
      font-size: 0.78rem;
      font-weight: 700;
      letter-spacing: 0.14em;
      text-transform: uppercase;
      opacity: 0.92;
    }

    .player-surname {
      font-size: clamp(1.35rem, 2.2vw, 1.8rem);
      line-height: 1.02;
      font-weight: 800;
      letter-spacing: -0.03em;
      text-wrap: balance;
    }

    .image-players {
      position: absolute;
      inset: 0;
      z-index: 1;
      border-radius: inherit;
      overflow: hidden;
      background:
        linear-gradient(
          180deg,
          rgba(255, 255, 255, 0.18),
          rgba(255, 255, 255, 0)
        ),
        url(${playerBackgroundImg});
      background-size: cover;
      background-position: center;
    }

    .img-container {
      object-fit: none;
      display: flex;
      justify-content: center;
      z-index: 1;
      width: 100%;
      height: 100%;
    }

    img {
      object-fit: cover;
      width: 100%;
      height: 100%;
      opacity: 1;
    }

    &.player-card--home .image-players img {
      object-fit: cover;
      width: 120%;
      height: 100%;
      opacity: 1;
      transform: translate(-20px, 30px) !important;
      @media (max-width: 650px) {
        transform: translate(-5px, 40px) !important;
      }
    }

    &.player-card--page .image-players {
      display: flex;
      align-items: center;
    }

    &.player-card--page .image-players img {
      height: 100%;
      width: 155%;
      opacity: 1;
      margin-bottom: 0;
      transform: translateY(40px) !important;
      @media (max-width: 450px) {
        margin-left: 90px;
      }
      @media (max-width: 650px) {
        transform: translateY(40px) !important;
      }
      @media (max-width: 2000px) {
        margin-left: -50px;
      }
      @media (min-width: 2000px) {
        margin-bottom: -75px;
        margin-left: -70px;
      }
    }

    @media (max-width: 700px) {
      position: relative !important;
      width: min(92vw, 310px);
      min-height: 340px;
      border-radius: 20px;
      transform: none !important;
      margin: 0 auto !important;
      .player-surname {
        font-size: clamp(1.2rem, 6vw, 1.6rem);
      }
    }

    @media (max-width: 550px) {
      width: min(94vw, 300px);
      min-height: 320px;
      .text-container {
        padding: 0.8rem 0.8rem 0.9rem;
      }
      .player-name {
        font-size: 0.66rem;
      }
      .player-surname {
        font-size: clamp(1.05rem, 6vw, 1.35rem);
      }
    }

    @media (max-width: 420px) {
      width: min(95vw, 290px);
      min-height: 310px;
    }

    &.player-card--mobile {
      position: relative !important;
      transform: none !important;
      width: min(92vw, 320px);
      min-height: 0;
      aspect-ratio: 3 / 4;
      margin: 0 auto 1rem !important;
    }
  }
`;
